var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ul',_vm._l((_vm.locations),function(loc){return _c('li',{key:loc.id},[_c('router-link',{attrs:{"to":{ name: 'volunteers', params: { id: loc.id } }}},[_vm._v(_vm._s(loc.name))])],1)}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }